/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Title_AccentInputs */

const tr_landing_genius_title_accent = /** @type {(inputs: Landing_Genius_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir AI ekibi.`)
};

const en_landing_genius_title_accent = /** @type {(inputs: Landing_Genius_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An AI team.`)
};

const de_landing_genius_title_accent = /** @type {(inputs: Landing_Genius_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein KI-Team.`)
};

const ru_landing_genius_title_accent = /** @type {(inputs: Landing_Genius_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это команда ИИ.`)
};

/**
* | output |
* | --- |
* | "An AI team." |
*
* @param {Landing_Genius_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_title_accent = /** @type {((inputs?: Landing_Genius_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_title_accent(inputs)
	if (locale === "de") return de_landing_genius_title_accent(inputs)
	if (locale === "ru") return ru_landing_genius_title_accent(inputs)
	return tr_landing_genius_title_accent(inputs)
});